var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 80",
    style: {
      enableBackground: "new 0 0 64 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,23c3,0,5.4-2.2,5.9-5h11.7l-1.3,1.3l1.4,1.4l3.7-3.7l-3.7-3.7l-1.4,1.4l1.3,1.3H14.9c-0.5-2.8-2.9-5-5.9-5 c-3.3,0-6,2.7-6,6S5.7,23,9,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.5,16h-6.6c-0.5-2.8-2.9-5-5.9-5c-3.3,0-6,2.7-6,6s2.7,6,6,6c3,0,5.4-2.2,5.9-5h6.6 C55.3,18,60,22.7,60,28.5S55.3,39,49.5,39H33.4l1.3-1.3l-1.4-1.4L29.6,40l3.7,3.7l1.4-1.4L33.4,41h16.1C56.4,41,62,35.4,62,28.5 S56.4,16,49.5,16z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 55,
    cy: 63,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27,57c-3.3,0-6,2.7-6,6s2.7,6,6,6c3,0,5.4-2.2,5.9-5h11.7l-1.3,1.3l1.4,1.4l3.7-3.7l-3.7-3.7l-1.4,1.4 l1.3,1.3H32.9C32.4,59.2,30,57,27,57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,64h2.1l-1.3,1.3l1.4,1.4l3.7-3.7l-3.7-3.7l-1.4,1.4l1.3,1.3h-2.1C8.7,62,4,57.3,4,51.5S8.7,41,14.5,41 h2.6c0.5,2.8,2.9,5,5.9,5c3.3,0,6-2.7,6-6s-2.7-6-6-6c-3,0-5.4,2.2-5.9,5h-2.6C7.6,39,2,44.6,2,51.5S7.6,64,14.5,64z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoms);
export default __webpack_public_path__ + "static/media/automs.40ca6d179a9f92e0b9e4ff10afb1a9f9.svg";
export { ForwardRef as ReactComponent };